<template>
  <BaseBoxColor variant="gray" class="w-full space-y-2 p-4">
    <div class="flex items-center justify-between">
      <h3>{{ name }}</h3>
      <BaseButton
        variant="danger"
        size="xs"
        :disabled="!debug_mode"
        @click="handleOnDelete(id)"
        >{{ $t("delete") }}</BaseButton
      >
    </div>
    <h4 class="text-white/75">#{{ code }}</h4>
    <p v-if="description">{{ description }}</p>
    <div class="w-full flex justify-between items-center">
      <div class="flex gap-8 items-center">
        <div>
          <h4 class="text-sm uppercase text-white/75">{{ $t("token") }}</h4>
          <BaseToken :token="token" />
        </div>
        <div>
          <h4 class="text-sm uppercase text-white/75">
            {{ $t("intent") }}
          </h4>
          <strong class="text-xl">{{ intentNumber }}</strong>
        </div>
      </div>
      <InputSwitch
        name="debug_mode"
        :label="$t('debugMode')"
        :initial-value="debug_mode"
        @change="emit('onDebugModeChange', { id, debug_mode: !debug_mode })"
      />
    </div>
    <GridRow>
      <GridCol :span-md="12" class="flex flex-col space-y-4">
        <StandardChart v-if="chartOptions" class="h-[12.5rem] w-full" :options="chartOptions" />
      </GridCol>
    </GridRow>
  </BaseBoxColor>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { StatisticsService } from "@/api/services";
import useModalStore from "@/stores/modal";
import { useI18n } from "vue-i18n";

const props = defineProps({
  id: Number,
  name: String,
  code: String,
  description: String,
  token: String,
  debug_mode: Boolean,
  intentNumber: {
    type: Number,
    default: 0,
  },
});

const emit = defineEmits(["onDebugModeChange", "onDeleteDim"]);
const modal = useModalStore();
const { t } = useI18n();
const chartOptions = ref()

/**
 * Handle on delete DIM, open confirm modal.
 * @param {number} id
 */
async function handleOnDelete(id) {
  const response = await modal.openConfirmModal({
    title: t("deleteDIM"),
  });

  if (response) {
    emit("onDeleteDim", id);
  }
}

onMounted(async () => {
  try{
    let tempStats = await StatisticsService.getStatistics("dim", props.id);
    chartOptions.value = tempStats.data.jsConfig
  } catch (e) {
    console.error(e)
  }
})
</script>
